import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useUploadClientLogo() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Envoie le logo du client sur le bucket S3 des logos.
   * @param {number} clientId - L'identifiant du client
   * @param {File} file - Le fichier image
   * @returns {Promise<string|null>} L'URL publique du logo, ou null en cas d'erreur
   */
  const uploadLogo = async (clientId, file) => {
    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.append('logo', file);

      const response = await fleetApi.post(
        `/super-admin/clients/${clientId}/logo`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      toast.success('Logo enregistré.');

      return response.data.logo_url;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    uploadLogo,
  };
}
